import { render, staticRenderFns } from "./PendencyMedicalRecords.html?vue&type=template&id=f31dbed2&external"
import script from "./PendencyMedicalRecords.vue?vue&type=script&lang=js"
export * from "./PendencyMedicalRecords.vue?vue&type=script&lang=js"
import style0 from "./PendencyMedicalRecords.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports